import React from 'react';


export const Part0DataSource = {
  wrapper: { className: ' uditrace-part0-wrapper' },
  page: { className: 'uditrace-part0' },
  OverPack: { playScale: 0.3, className: '' },
  childWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: 'CanHealthy',
        className: 'title-h1',
      },
      {
        name: 'title',
        children: 'AI Vision-Based UDI Traceability System for Medical Consumables',
        className: 'title-h2',
      },

      {
        name: 'content',
        className: 'title-content uditrace-part0-title-content',
        children: '基于视觉AI的医用耗材UDI码追溯系列',
      },
    ],
  },
  video: {
    className: 'uditrace-part0-video',
    children: {
      video: process.env.SOURCE_URL+'/udi-nailtool-intro.mp4',
      image: process.env.SOURCE_URL+'/lipstick-img-1.png',
    },
  },
  image: {
    className: 'uditrace-part0-image',
    children:
    process.env.SOURCE_URL+'/udi-main.png',
  },

};

export const Part1DataSource = {
  wrapper: { className: 'uditrace-part1-wrapper'},
  page: { className: 'uditrace-part1 part1-page' },
  content:{
    className:'part1-content',
    children: (
      <div>
        <h3>完善的产品系列</h3>
        <h1>物流仓 | 城市仓 | 近院仓 | 供应室</h1>
      </div>
    ),
  },
}

export const Part2DataSource = {
  wrapper: { className: 'uditrace-part2-wrapper'},
  page: { className: 'uditrace-part2' },
  OverPack: { playScale: 0.3, className: 'uditrace-part2-imgs' },
  content:{
    className:'part2-content',
    children: (
      <div>
        <h1>识码能力强</h1>
        <h3>GS1标准 | 国家药监局核准的一维、二维UDI码制</h3>
      </div>
    ),
  },
  imageL: {
    className: 'uditrace-part3-image',
    children:
    process.env.SOURCE_URL+'/udi-part3.png',
  },
  imageR: {
    className: 'uditrace-part3-image',
    children:
    process.env.SOURCE_URL+'/udi-part3-right.png',
  },
}
export const Part3DataSource = {
  wrapper: { className: 'uditrace-part3-wrapper'},
  page: { className: 'uditrace-part3' },
  OverPack: { playScale: 0.3, className: '' },
  content:{
    className:'part3-content',
    children: (
      <div>
        <h1>解码速度快</h1>
        <h3>一维码90个码/秒 | 二维码45个码/秒</h3>
      </div>
    ),
  },
  image: {
    className: 'uditrace-part3-image',
    children:
    process.env.SOURCE_URL+'/udi-part3-data.png',
  },
}

export const Part4DataSource = {
  wrapper: { className: 'home-page-wrapper uditrace-part4-wrapper' },
  page: { className: 'home-page uditrace-part4' },
  OverPack: { playScale: 0.3 },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: '产品系列丰富',
        className: 'title-h1',
      },
      {
        name: 'content',
        className: 'title-content',
        children: '',
      },
    ],
  },
  block: {
    className: 'uditrace-part4-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'uditrace-part4-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'uditrace-part4-icon',
            children:
              'https://zos.alipayobjects.com/rmsportal/ScHBSdwpTkAHZkJ.png',
          },
          textWrapper: { className: 'uditrace-part4-text' },
          title: { className: 'uditrace-part4-title', children: 'U50' },
          content: {
            className: 'uditrace-part4-content',
            children:
              '小型化设计占地小；高精度读码器结合AI分割技术，实现产品外形区分与秒级核验。',
          },
        },
      },
      {
        name: 'block1',
        className: 'uditrace-part4-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'uditrace-part4-icon',
            children:
              'https://zos.alipayobjects.com/rmsportal/NKBELAOuuKbofDD.png',
          },
          textWrapper: { className: 'uditrace-part4-text' },
          title: { className: 'uditrace-part4-title', children: 'U50Pi' },
          content: {
            className: 'uditrace-part4-content',
            children:
              '集成转码打印与生物识别模块，支持自动赋码与权限控制；具备AI外形识别与高速读码能力。',
          },
        },
      },
      {
        name: 'block2',
        className: 'uditrace-part4-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'uditrace-part4-icon',
            children:
              'https://zos.alipayobjects.com/rmsportal/xMSBjgxBhKfyMWX.png',
          },
          textWrapper: { className: 'uditrace-part4-text' },
          title: { className: 'uditrace-part4-title', children: 'U50D(m)' },
          content: {
            className: 'uditrace-part4-content',
            children:
              '多相机配置扩大检测范围，支持多角度批量清点；具备AI外形分割与秒级核验功能。',
          },
        },
      },
      {
        name: 'block3',
        className: 'uditrace-part4-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'uditrace-part4-icon',
            children:
              'https://zos.alipayobjects.com/rmsportal/MNdlBNhmDBLuzqp.png',
          },
          textWrapper: { className: 'uditrace-part4-text' },
          title: { className: 'uditrace-part4-title', children: 'U700' },
          content: {
            className: 'uditrace-part4-content',
            children:
              '自下而上成像设计，可识别条码面高度差超200mm的耗材；具备AI实时读码与核验能力。',
          },
        },
      },
      {
        name: 'block4',
        className: 'uditrace-part4-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'uditrace-part4-icon',
            children:
              'https://zos.alipayobjects.com/rmsportal/UsUmoBRyLvkIQeO.png',
          },
          textWrapper: { className: 'uditrace-part4-text' },
          title: { className: 'uditrace-part4-title', children: 'M20m' },
          content: {
            className: 'uditrace-part4-content',
            children:
              '通过文本分析算法识别无追溯码药品包装；智能读码器实现秒级解码与外形区分。',
          },
        },
      },
      // {
      //   name: 'block5',
      //   className: 'uditrace-part4-block',
      //   md: 8,
      //   xs: 24,
      //   children: {
      //     icon: {
      //       className: 'uditrace-part4-icon',
      //       children:
      //         'https://zos.alipayobjects.com/rmsportal/ipwaQLBLflRfUrg.png',
      //     },
      //     textWrapper: { className: 'uditrace-part4-text' },
      //     title: { className: 'uditrace-part4-title', children: '待提供11' },
      //     content: {
      //       className: 'uditrace-part4-content',
      //       children:
      //         '待提供12',
      //     },
      //   },
      // },
    ],
  },
};

export const Part5DataSource = {
  wrapper: { className: 'home-page-wrapper uditrace-part5-wrapper' },
  page: { className: 'home-page uditrace-part5' },
  childWrapper: {
    className: 'uditrace-part5-text-wrapper',
    children: [
      { name: 'title', children: '视觉AI加持 不止于识码', className: 'uditrace-part5-title' },
      {
        name: 'intro',
        className: 'uditrace-part5-intro',
        children: '辅助清点数量 | 解决一物多码、多物多码',
      },

    ],
  },
  image: {
    className: 'uditrace-part5-image',
    children:
      process.env.SOURCE_URL+'/udi-part5.png',
  },
};
export const Part6DataSource = {
  wrapper: { className: 'home-page-wrapper uditrace-part6-wrapper' },
  page: { className: 'home-page uditrace-part6' },
  childWrapper: {
    className: 'uditrace-part6-text-wrapper',
    children: [
      // { name: 'title', children: '黑金刚2.0', className: 'banner5-title' },
      {
        name: 'intro',
        className: 'uditrace-part6-intro',
        children: '待提供15',
      },

    ],
  },
  image: {
    className: 'uditrace-part6-image',
    children:
      process.env.SOURCE_URL+'/6.png',
  },
};

export const Part7DataSource = {
  wrapper: { className: 'home-page-wrapper uditrace-part7-wrapper' },
  page: { className: 'home-page uditrace-part7' },
  OverPack: { playScale: 0.3, className: 'uditrace-part7-content-wrapper' },
  titleWrapper: {
    className: 'uditrace-part7-title-wrapper',
    children: [
      { name: 'title', children: '多种订阅方式', className: 'uditrace-part7-title-h1' },
    ],
  },
  Table: {
    name: 'tabsTitle',
    size: 'default',
    className: 'uditrace-part7-table',
    columns: {
      children: [
        {
          dataIndex: 'free',
          key: 'free',
          name: 'free',
          childWrapper: {
            className: 'uditrace-part7-table-name-block',
            children: [
              {
                name: 'name',
                className: 'uditrace-part7-table-name',
                children: '永久授权',
              },
            ],
          },
        },
        {
          dataIndex: 'basic',
          key: 'basic',
          name: 'basic',
          childWrapper: {
            className: 'uditrace-part7-table-name-block',
            children: [
              {
                name: 'name',
                className: 'uditrace-part7-table-name',
                children: '订阅授权',
              },
            ],
          },
        },
        {
          dataIndex: 'pro',
          key: 'pro',
          name: 'pro',
          childWrapper: {
            className: 'uditrace-part7-table-name-block',
            children: [
              {
                name: 'name',
                className: 'uditrace-part7-table-name',
                children: '质检包授权',
              },
            ],
          },
        },
        {
          dataIndex: 'unlimited',
          key: 'unlimited',
          name: 'unlimited',
          childWrapper: {
            className: 'uditrace-part7-table-name-block',
            children: [
              {
                name: 'name',
                className: 'uditrace-part7-table-name',
                children: '定制开发',
              },
            ],
          },
        },
      ],
    },
    dataSource: {
      children: [
        {
          name: 'list0',
          children: [
            {
              children: '一次性建设',
              name: 'content0',
              className: 'uditrace-part7-table-content',
            },
            {
              children: '按年采用订阅的方式',
              name: 'content1',
              className: 'uditrace-part7-table-content',
            },
            {
              children: '质检包授权',
              name: 'content2',
              className: 'uditrace-part7-table-content',
            },
            {
              children: '定制开发',
              name: 'content3',
              className: 'uditrace-part7-table-content',
            },
          ],
        },
      ],
    },
  },
};


export const Part8DataSource = {
  wrapper: { className: ' uditrace-part8-wrapper home-page-wrapper' },
  page: { className: 'uditrace-part8 home-page' },
  OverPack: { playScale: 0.3, className: '' },
  childWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: '我们的特色：AI + 集成',
        className: 'title-h1',
      },
      {
        name: 'content',
        className: 'title-h1',
        children: '用实例说话',
      },
    ],
  },
  image: {
    className: 'uditrace-part8-image',
    children:
    process.env.SOURCE_URL+'/lipstick-prod-1.jpeg',
  },

};


export const Part9DataSource = {
  wrapper: {
    className: ' case-wrapper-comp-wrapper',
  },
  page: {
    className: 'case-wrapper-comp',
  },
  OverPack: {
    playScale: 0.3,
    className: '',
  },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: 'CanHealthy系列更多产品',
      },
    ],
  },
  block: {
    className: 'block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'block',
        href:'/jetcode',
        md: 8,
        xs: 24,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'case-wrapper-comp-image',
              children: process.env.SOURCE_URL+'/canhealthy-nail.png',
            },
            {
              name: 'title',
              className: 'case-wrapper-comp-title',
              children: '骨科内固定器械清点系列',
            },
          ],
        },
      },
      {
        name: 'block1',
        className: 'block',
        href:'/csar',
        md: 8,
        xs: 24,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'case-wrapper-comp-image',
              children: process.env.SOURCE_URL+'/canhealthy-part3-main.png',

            },
            {
              name: 'title',
              className: 'case-wrapper-comp-title',
              children: '手术工具清点系列',
            },
          ],
        },
      },

      // {
      //   name: 'block2',
      //   className: 'block',
      //   md: 8,
      //   xs: 24,
      //   titleWrapper: {
      //     children: [

      //       {
      //         name: 'title',
      //         className: 'case-wrapper-comp-title title-1',
      //         children: '持续推出',
      //       },
      //     ],
      //   },
      // },
    ],
  },
}
